<template>
  <directory />
</template>

<script>
import Directory from './components/Directory.vue'

export default {
  name: 'App',
  components: { directory: Directory }
}
</script>
